// Simple or Professional tools, chosen per device. Simple is the default and
// keeps survey checks, evidence review and saved Undo out of the way.
// Browser automation starts in Professional unless a test chooses otherwise,
// so scripted suites exercise every tool.
import { useSyncExternalStore } from 'react';

const KEY = 'aviseraplanner.toolMode', listeners = new Set();
let override = null;

export function toolMode() {
  if (override) return override;
  let stored = null;
  try { stored = localStorage.getItem(KEY); } catch { /* storage unavailable: use the default */ }
  if (stored === 'simple' || stored === 'professional') return stored;
  return typeof navigator !== 'undefined' && navigator.webdriver ? 'professional' : 'simple';
}

export function setToolMode(mode) {
  const value = mode === 'professional' ? 'professional' : 'simple';
  try { localStorage.setItem(KEY, value); override = null; } catch { override = value; }
  for (const listener of listeners) listener();
}

const subscribe = listener => { listeners.add(listener); return () => listeners.delete(listener); };
/** Re-renders when the mode changes anywhere in the editor. */
export const useToolMode = () => useSyncExternalStore(subscribe, toolMode, toolMode);
export const useProfessional = () => useToolMode() === 'professional';
